import React from "react";
import formBanner from "../../Images/SignupForm/formBanner.jpg";

function DocUploadHero({ variant = "sidebar", badge, title, subtitle }) {
  return (
    <div className={`doc-upload-hero doc-upload-hero--${variant}`}>
      <img
        src={formBanner}
        alt=""
        className="doc-upload-hero-image"
        aria-hidden="true"
      />
      <div className="doc-upload-hero-overlay" aria-hidden="true" />
      <div className="doc-upload-hero-content">
        {badge}
        <h1 className="doc-upload-hero-title">{title}</h1>
        <p className="doc-upload-hero-subtitle">{subtitle}</p>
      </div>
    </div>
  );
}

export default DocUploadHero;
